import { BrowserModule } from '@angular/platform-browser';
import { NgModule ,CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { UserPageComponent } from './feature/user-page/user-page.component';
import { AdminPageComponent } from './feature/admin-page/admin-page.component';
import { HomepageComponent } from './feature/homepage/homepage.component';
import { ErrorPageComponent } from './feature/error-page/error-page.component';
import { NavHeaderComponent } from './shared/nav-header/nav-header.component';
import { DropdownUserComponent } from './shared/dropdown-user/dropdown-user.component';
import { CookieService } from 'ngx-cookie-service';
import { PreloadComponent } from './feature/preload/preload.component';
import { TokenInterceptor } from './core/token.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PlatformLogoutComponent } from './feature/platform-logout/platform-logout.component'; 
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ManageChildOrgViewComponent } from './feature/manage-child-org/manage-child-org-view/manage-child-org-view.component';
import { ManageChildOrgCreateComponent } from './feature/manage-child-org/manage-child-org-create/manage-child-org-create.component';
import { ManageChildOrgEditComponent } from './feature/manage-child-org/manage-child-org-edit/manage-child-org-edit.component';
import { ManageChildOrgMapComponent } from './feature/manage-child-org/manage-child-org-map/manage-child-org-map.component';
import { environment } from 'src/environments/environment';
import { AgmCoreModule } from '@agm/core';

@NgModule({
  declarations: [
    AppComponent,
    UserPageComponent,
    AdminPageComponent,
    HomepageComponent,
    ErrorPageComponent,
    NavHeaderComponent,
    DropdownUserComponent,
    PreloadComponent,
    PlatformLogoutComponent,
    ManageChildOrgViewComponent,
    ManageChildOrgCreateComponent,
    ManageChildOrgEditComponent,
    ManageChildOrgMapComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSpinnerModule,
    BrowserAnimationsModule,
    AgmCoreModule.forRoot({
      apiKey: environment.GOOGLE_KEY,
      libraries: ['drawing', 'places', 'geometry']
    }),
  ],
  providers: [CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
